import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M35.5 18C35.5 27.665 27.665 35.5 18 35.5C8.33502 35.5 0.5 27.665 0.5 18C0.5 8.33502 8.33502 0.5 18 0.5C27.665 0.5 35.5 8.33502 35.5 18Z\" stroke=\"#454342\"></path><g clip-path=\"url(#clip0_2790_14627)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.727 18.6296H24.2734V17.375H11.727V18.6296Z\" fill=\"#454342\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.1206 12.7227L10.8422 18.0011L16.1206 23.2795L17.0078 22.3923L12.6166 18.0011L17.0078 13.6098L16.1206 12.7227Z\" fill=\"#454342\"></path></g><defs><clipPath id=\"clip0_2790_14627\"><rect width=\"15.0557\" height=\"15.0558\" fill=\"white\" transform=\"matrix(-1 0 0 1 25.5273 10.4727)\"></rect></clipPath></defs>", 3)
  ])))
}
export default { render: render }